import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import axios from "axios";
import { detect } from "detect-browser";
import { navigate } from "gatsby";
import { getCompleteStatus } from "./api/payment";
import { CONSTANTS } from "./qnb-const";
export function base64DataUrlToFile(_x, _x2, _x3) { return _base64DataUrlToFile.apply(this, arguments); }
function _base64DataUrlToFile() { _base64DataUrlToFile = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(url, fileName, dataType) { var f; return _regeneratorRuntime.wrap(function _callee$(_context) { while (1) {
    switch (_context.prev = _context.next) {
        case 0:
            if (fileName === void 0) {
                fileName = "webcam.jpg";
            }
            if (dataType === void 0) {
                dataType = "image/jpeg";
            }
            _context.next = 4;
            return axios.get(url, { responseType: "arraybuffer" });
        case 4:
            f = _context.sent;
            return _context.abrupt("return", new File([f.data], fileName, { type: dataType }));
        case 6:
        case "end": return _context.stop();
    }
} }, _callee); })); return _base64DataUrlToFile.apply(this, arguments); }
export function jsonToContentTypedBlob(_x4) { return _jsonToContentTypedBlob.apply(this, arguments); }
function _jsonToContentTypedBlob() { _jsonToContentTypedBlob = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(json) { return _regeneratorRuntime.wrap(function _callee2$(_context2) { while (1) {
    switch (_context2.prev = _context2.next) {
        case 0: return _context2.abrupt("return", new Blob([JSON.stringify(json)], { type: "application/json" }));
        case 1:
        case "end": return _context2.stop();
    }
} }, _callee2); })); return _jsonToContentTypedBlob.apply(this, arguments); }
export function stopOnError(obj) { if (obj.error) {
    throw new Error("Error on submitting form.");
} }
export function getIamsSource() { var browserInfo = detect(); if ((browserInfo === null || browserInfo === void 0 ? void 0 : browserInfo.os) === "Android OS") {
    switch (browserInfo.name) {
        case "chrome":
        case "chromium-webview": return "Android_Chrome";
        case "edge":
        case "edge-chromium": return "Android_Edge";
        case "firefox": return "Android_Firefox";
        case "samsung": return "Android_Samsung";
        case "miui": return "Android_Xiaomi";
    }
} if ((browserInfo === null || browserInfo === void 0 ? void 0 : browserInfo.os) === "iOS") {
    switch (browserInfo.name) {
        case "safari":
        case "ios": return "iOS_Safari";
        case "chrome":
        case "crios": return "iOS_Chrome";
        case "edge":
        case "edge-ios":
        case "edge-chromium": return "iOS_Edge";
        case "firefox": return "iOS_Firefox";
    }
} return "PC_Browser"; }
export function checkRecommendBrowser() { var browserInfo = detect(); if ((browserInfo === null || browserInfo === void 0 ? void 0 : browserInfo.type) !== "browser")
    return false; var browserName = browserInfo === null || browserInfo === void 0 ? void 0 : browserInfo.name; if (browserName === "chrome" || browserName === "chromium-webview" || browserName === "edge" || browserName === "edge-chromium" || browserName === "firefox" || browserName === "fxios" || browserName === "safari" || browserName === "ios" || browserName === "crios" || browserName === "edge-ios") {
    return false;
} return true; }
export function setInputFilter(textbox, inputFilter) { var evtListener = function evtListener() { if (inputFilter(this.value)) {
    this.oldValue = this.value;
    this.oldSelectionStart = this.selectionStart;
    this.oldSelectionEnd = this.selectionEnd;
}
else if (Object.prototype.hasOwnProperty.call(this, "oldValue")) {
    this.value = this.oldValue;
    if (this.oldSelectionStart !== null && this.oldSelectionEnd !== null) {
        this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
    }
}
else {
    this.value = "";
} }; var events = ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"]; events.forEach(function (event) { textbox.addEventListener(event, evtListener); }); return [events, evtListener]; }
export function handleToken(token, quoteNo) { var _localStorage$getItem; var tokenStr = (_localStorage$getItem = localStorage.getItem("qnbToken")) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : "{\"sex\": \"0\",\n    \"height\":\"181\",\n    \"weight\":\"75\",\n    \"age\": 18,\n    \"smoke\": 0}"; var tokens = JSON.parse(tokenStr); tokens[quoteNo] = { token: token }; localStorage.setItem("qnbToken", JSON.stringify(tokens)); }
export function getUserToken(quoteNo) { var _localStorage$getItem2, _tokens$quoteNo$token, _tokens$quoteNo; var tokenStr = (_localStorage$getItem2 = localStorage.getItem("qnbToken")) !== null && _localStorage$getItem2 !== void 0 ? _localStorage$getItem2 : "{}"; var tokens = JSON.parse(tokenStr); return (_tokens$quoteNo$token = (_tokens$quoteNo = tokens[quoteNo]) === null || _tokens$quoteNo === void 0 ? void 0 : _tokens$quoteNo.token) !== null && _tokens$quoteNo$token !== void 0 ? _tokens$quoteNo$token : ""; }
export function proceedToComplete(_x5) { return _proceedToComplete.apply(this, arguments); }
function _proceedToComplete() { _proceedToComplete = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee3(quoteInfo) { return _regeneratorRuntime.wrap(function _callee3$(_context3) { while (1) {
    switch (_context3.prev = _context3.next) {
        case 0:
            _context3.next = 2;
            return getCompleteStatus({ useSubmitTime: true, proposalSid: quoteInfo.proposalSid, policyNo: quoteInfo.policyNo }).then(function (res) { var _res$data$quoteMainDt, _res$data$quoteMainDt2; var completeFR = (_res$data$quoteMainDt = res.data.quoteMainDto) === null || _res$data$quoteMainDt === void 0 ? void 0 : (_res$data$quoteMainDt2 = _res$data$quoteMainDt.geQuotePartyDtos.find(function (m) { return m.partyFlag === "1"; })) === null || _res$data$quoteMainDt2 === void 0 ? void 0 : _res$data$quoteMainDt2.completeFR; navigate("../thankyou?proposalSid=" + quoteInfo.proposalSid + "&policyNo=" + quoteInfo.policyNo, { state: Object.assign({}, res.data, { completeFR: completeFR }) }); });
        case 2:
        case "end": return _context3.stop();
    }
} }, _callee3); })); return _proceedToComplete.apply(this, arguments); }
export function checkLinkExternal(url) { if (url == null) {
    return undefined;
} if (/^(https?:\/\/)|(\/online\/)|(\/static\/)|(#)/i.test(url)) {
    return true;
} return false; }
export var transferUrlParams = function transferUrlParams(url, shouldTransfer) { if (!url) {
    return "";
} if (typeof window !== "object")
    return url; var currentURLSearch = window.location.search; var params = new URLSearchParams(currentURLSearch); var paramsToTransfer = []; params.forEach(function (_, key) { if (shouldTransfer(key)) {
    paramsToTransfer.push(key);
} }); if (paramsToTransfer.length === 0) {
    return url;
} var hashIndex = url.indexOf("#"); var urlWithoutHash = url; var hash = ""; if (hashIndex !== -1) {
    hash = url.substring(hashIndex);
    urlWithoutHash = url.substring(0, hashIndex);
} var newParams = new URLSearchParams(""); var queryIndex = urlWithoutHash.indexOf("?"); var path = urlWithoutHash; if (queryIndex !== -1) {
    path = urlWithoutHash.substring(0, queryIndex);
    var existingQuery = urlWithoutHash.substring(queryIndex);
    var urlParam = new URLSearchParams(existingQuery);
    urlParam.forEach(function (value, key) { newParams.set(key, value); });
} paramsToTransfer.forEach(function (key) { var _params$get; newParams.set(key, (_params$get = params.get(key)) !== null && _params$get !== void 0 ? _params$get : ""); }); return path + "?" + newParams.toString() + hash; };
export var replaceURLDiscount = function replaceURLDiscount(url) { return transferUrlParams(url, function (key) { return key.startsWith("discountCode") || [CONSTANTS.AGE, CONSTANTS.SAVING_AMOUNT, CONSTANTS.PAYMENT_FREQUENCY, CONSTANTS.PLAN].includes(key); }); };
export var appEventHandler = function appEventHandler(eventName) {
    var event = new CustomEvent(eventName); // const event = new CustomEvent(eventName, { data: "" });
    window.dispatchEvent(event);
};
export var getCookie = function getCookie(cname) { var name = cname + "="; var ca = document.cookie.split(";"); for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
        c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
    }
} return ""; };
export var replaceURLPartner = function replaceURLPartner(url) { return transferUrlParams(url, function (key) { return key.startsWith("partnerCode") || key.startsWith("channel"); }); };
export function isMobileApp() { return getCookie("WEB_VIEW") == "true"; }
export var findByPlanFlag = function findByPlanFlag(planPremiumDtos, planFlag) { return planPremiumDtos.find(function (el) { return el.planFlag === planFlag; }); };
export var isSpecialEmploymentStatus = function isSpecialEmploymentStatus(status) { return status === "3" || status === "5" || status === "7" || status === "6"; };
export var isSelfEmplEmploymentStatus = function isSelfEmplEmploymentStatus(status) { return status === "1"; };
export var convertToFullLocaleFormat = function convertToFullLocaleFormat(locale) { switch (locale) {
    case "hk": return "zh_HK";
    case "cn": return "zh_CN";
    case "en":
    default: return "en_US";
} };
export var isMobile = function isMobile() { var isPhone = /phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone/i.test(navigator.userAgent); if (isPhone) {
    return true;
}
else {
    return false;
} };
